import { Navigate } from 'react-router-dom';
import { useSessionStorage } from '../../../hooks';
import React, { useState } from 'react';

import {
  Container
} from './styled';




export const ContentContainer = (props:any) => {
  // const [authenticated, setAuthenticated] = useSessionStorage('authenticated');
  // if (authenticated)
    return (
      <Container> 
       {props.children}  
      </Container>
    );
  return <Navigate to='/' replace />;

};
